import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../api/client';

type PermissionKey =
  | 'dashboard.view' | 'dashboard.kpi' | 'dashboard.charts' | 'dashboard.feed' | 'dashboard.activity' | 'dashboard.report'
  | 'calendar.view' | 'calendar.edit'
  | 'clients.view' | 'clients.create' | 'clients.edit' | 'clients.delete'
  | 'events.view' | 'events.create' | 'events.edit' | 'events.delete' | 'events.financial'
  | 'events.overview.view'
  | 'events.services.view' | 'events.services.edit'
  | 'events.scaletta.view' | 'events.scaletta.edit'
  | 'events.collaborators.view' | 'events.collaborators.edit'
  | 'events.post-production.view' | 'events.post-production.edit'
  | 'events.files.view' | 'events.files.edit'
  | 'events.contract.view' | 'events.contract.edit'
  | 'events.timeline.view'
  | 'collaborators.view' | 'collaborators.manage'
  | 'projects.view' | 'projects.manage' | 'projects.financial'
  | 'external-photographers.view' | 'external-photographers.manage'
  | 'performances.view' | 'performances.manage'
  | 'performances.catalog.view' | 'performances.catalog.edit'
  | 'performances.my.view' | 'performances.my.manage'
  | 'performances.all.view' | 'performances.all.manage'
  | 'catalog.view' | 'catalog.manage'
  | 'catalog.packages.view' | 'catalog.packages.edit'
  | 'catalog.checklist.view' | 'catalog.checklist.edit'
  | 'catalog.contracts.view' | 'catalog.contracts.edit'
  | 'catalog.collaborator-templates.view' | 'catalog.collaborator-templates.edit'
  | 'suppliers.view'
  | 'documents.view' | 'documents.edit'
  | 'reports.view' | 'reports.export'
  | 'finance.view' | 'finance.edit'
  | 'notifications.view'
  | 'settings.view' | 'settings.edit'
  | 'settings.studio.view' | 'settings.studio.edit'
  | 'settings.notifications.view' | 'settings.notifications.edit'
  | 'settings.calendar.view' | 'settings.calendar.edit'
  | 'settings.documents.view' | 'settings.documents.edit'
  | 'settings.system.view' | 'settings.system.edit'
  | 'users.manage';

export function usePermissions() {
  const { data, isLoading } = useQuery({
    queryKey: ['my-permissions'],
    queryFn: () => apiGet<Record<string, boolean>>('/role-permissions/my'),
    staleTime: 30 * 1000,
  });

  return {
    permissions: (data ?? {}) as Record<string, boolean>,
    isLoading,
    hasPermission: (key: PermissionKey) => data?.[key] ?? false,
  };
}
